import React, { useState } from "react";
import "./AporteSaque.css";
import { ModalAporte } from "../../../components/modais/ModalAporte";
import { ModalSaque } from "../../../components/modais/ModalSaque";
import { obterDadosUsuario2 } from "../../../services/cookies";
import { ClientePageShell } from "../../../components/ClientePageShell";

import { FiArrowDownCircle, FiArrowUpCircle, FiClock, FiShield } from "react-icons/fi";

export interface Dados {
    token: string;
    tokenRenovacao: string;
    email: string;
    id: string;
}

const AporteSaque = () => {
    const [modalAporte, setModalAporte] = useState<boolean>(false);
    const [modalSaque, setModalSaque] = useState<boolean>(false);
    const dados: Dados = obterDadosUsuario2();

    return (
        <ClientePageShell
            className="aporte-saque-page"
            eyebrow="Movimentações"
            title="Aporte e Saque"
            subtitle="Abra solicitações de entrada ou retirada com acompanhamento operacional pela equipe Omex Capital."
        >
            <section className="cliente-page-panel aporte-saque-panel">
                <div className="cliente-page-section-header">
                    <div>
                        <p>Operação</p>
                        <h2>Escolha a transação</h2>
                    </div>
                    <span>Solicitações são registradas com validação de segurança.</span>
                </div>

                <div className="aporte-saque-grid">
                    <button
                        className="aporte-saque-card aporte-saque-card-aporte"
                        type="button"
                        onClick={() => setModalAporte(true)}
                    >
                        <span className="aporte-saque-card-icon">
                            <FiArrowDownCircle />
                        </span>
                        <strong>Aporte</strong>
                        <small>Envie os dados do depósito e anexe o comprovante para validação.</small>
                    </button>

                    <button
                        className="aporte-saque-card aporte-saque-card-saque"
                        type="button"
                        onClick={() => setModalSaque(true)}
                    >
                        <span className="aporte-saque-card-icon">
                            <FiArrowUpCircle />
                        </span>
                        <strong>Saque</strong>
                        <small>Solicite retirada para sua conta cadastrada e acompanhe o status pelo extrato.</small>
                    </button>
                </div>
            </section>

            <section className="aporte-saque-info-grid" aria-label="Informações de operação">
                <article>
                    <FiShield />
                    <div>
                        <strong>Ambiente autenticado</strong>
                        <span>Movimentações usam sua sessão ativa e os dados financeiros selecionados.</span>
                    </div>
                </article>
                <article>
                    <FiClock />
                    <div>
                        <strong>Fluxo acompanhado</strong>
                        <span>Depois do envio, o histórico da operação fica disponível em Extrato.</span>
                    </div>
                </article>
            </section>

            <ModalAporte modal={modalAporte} dadosUsuario={dados} setModal={() => setModalAporte(false)} />
            <ModalSaque modal={modalSaque} setModal={() => setModalSaque(false)} dadosUsuario={dados} />
        </ClientePageShell>
    );
};

export default AporteSaque;
